import { render, staticRenderFns } from "./LanRateio.vue?vue&type=template&id=09a82476&scoped=true"
import script from "./LanRateio.vue?vue&type=script&lang=js"
export * from "./LanRateio.vue?vue&type=script&lang=js"
import style0 from "./LanRateio.vue?vue&type=style&index=0&id=09a82476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a82476",
  null
  
)

export default component.exports